// htmx keeps a snapshot of <body> for the back button. The snapshot includes
// the elements Alpine generated from <template x-for> and <template x-if>;
// when it is swapped back in, Alpine initialises those copies outside their
// loop scope and every loop variable ("state", "mod", ...) throws a
// ReferenceError. The generated elements are therefore marked before the
// snapshot and stripped from the cached HTML before it is restored; Alpine
// re-creates them from their templates. <template x-teleport> is the same
// case: its clone lives elsewhere in <body> (the date picker popup) and would
// be initialised without the scope of the component it came from.

export const GENERATED_ATTR = "data-alpine-generated";

type AlpineTemplate = {
  _x_lookup?: Record<string, Element>;
  _x_currentIfEl?: Element;
  _x_teleport?: Element;
};

export function markAlpineGenerated(root: ParentNode): void {
  root.querySelectorAll("template").forEach((node) => {
    const tpl = node as unknown as AlpineTemplate;
    Object.values(tpl._x_lookup ?? {}).forEach((el) => el.setAttribute(GENERATED_ATTR, ""));
    tpl._x_currentIfEl?.setAttribute(GENERATED_ATTR, "");
    tpl._x_teleport?.setAttribute(GENERATED_ATTR, "");
  });
}

export function stripAlpineGenerated(html: string): string {
  const tpl = document.createElement("template");
  tpl.innerHTML = html;
  tpl.content.querySelectorAll(`[${GENERATED_ATTR}]`).forEach((el) => el.remove());
  return tpl.innerHTML;
}
